import { Link } from "react-router-dom";
import { Reveal, Overline } from "@/components/motion";

export const LegalPage = ({ overline, title, updated, children, testid }) => (
  <div data-testid={testid} className="pt-20">
    <div className="mx-auto max-w-3xl px-6 py-24 lg:py-32">
      <Reveal>
        <Overline className="mb-6">{overline}</Overline>
        <h1 className="font-serif text-4xl font-light text-ivory sm:text-5xl">{title}</h1>
        <p className="mt-4 text-xs uppercase tracking-[0.25em] text-mist">
          Ultima actualizare: {updated}
        </p>
      </Reveal>
      <div className="mt-12 space-y-10 text-sm leading-relaxed text-mist">{children}</div>
      <p className="mt-16 border-t border-white/10 pt-8 text-sm text-mist">
        Întrebări?{" "}
        <Link to="/contact" className="text-gold transition-colors hover:text-gold-hover">
          Scrie-ne sau sună-ne
        </Link>
        .
      </p>
    </div>
  </div>
);

export const LegalSection = ({ title, children }) => (
  <section>
    <h2 className="mb-4 font-serif text-xl text-ivory">{title}</h2>
    {children}
  </section>
);
